import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  messages: [],
  currentPhaseIndex: 0,
  phases: [],
  isShowSampleAnswer: true,
  userIdeaHistoryId: '',
  isLoadingBot: false,
  isFinish: false,
  audioFileUser: null,
  userIdea: null,
  audio: {},
}

export const learnPartTwoSlice = createSlice({
  name: 'learnPartTwo',
  initialState,
  reducers: {
    updateMessages: (state, action) => {
      state.messages = action.payload
    },
    updateCurrentPhaseIndex: (state, action) => {
      state.currentPhaseIndex = action.payload
    },
    updatePhases: (state, action) => {
      state.phases = action.payload
    },
    updateIsShowSampleAnswer: (state, action) => {
      state.isShowSampleAnswer = action.payload
    },
    updateUserIdeaHistoryId: (state, action) => {
      state.userIdeaHistoryId = action.payload
    },
    updateIsLoadingBot: (state, action) => {
      state.isLoadingBot = action.payload
    },
    updateIsFinish: (state, action) => {
      state.isFinish = action.payload
    },
    updateAudioFileUser: (state, action) => {
      state.audioFileUser = action.payload
    },
    updateUserIdea: (state, action) => {
      state.userIdea = action.payload
    },
    updateAudio: (state, action) => {
      state.audio = action.payload
    },
    reset: state => {
      state.messages = []
      state.currentPhaseIndex = 0
      state.phases = []
      state.isShowSampleAnswer = true
      state.userIdeaHistoryId = ''
      state.isLoadingBot = false
      state.isFinish = false
      state.audioFileUser = null
      state.userIdea = null
      state.audio = {}
    },
  },
})

export const {
  updateMessages,
  updateCurrentPhaseIndex,
  updatePhases,
  updateIsShowSampleAnswer,
  updateUserIdeaHistoryId,
  updateIsLoadingBot,
  updateIsFinish,
  updateAudioFileUser,
  updateUserIdea,
  updateAudio,
  reset,
} = learnPartTwoSlice.actions
export default learnPartTwoSlice.reducer
